import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ProductsAdmin from "@/components/admin/ProductsAdmin";
import OrdersAdmin from "@/components/admin/OrdersAdmin";
import VouchersAdmin from "@/components/admin/VouchersAdmin";
import NewsletterAdmin from "@/components/admin/NewsletterAdmin";
import ContentAdmin from "@/components/admin/ContentAdmin";
import ShippingAdmin from "@/components/admin/ShippingAdmin";
import CategoriesAdmin from "@/components/admin/CategoriesAdmin";
import StatsAdmin from "@/components/admin/StatsAdmin";

const TABS = [
  { key: "products", label: "Produse", C: ProductsAdmin },
  { key: "categories", label: "Categorii", C: CategoriesAdmin },
  { key: "orders", label: "Comenzi", C: OrdersAdmin },
  { key: "stats", label: "Statistici", C: StatsAdmin },
  { key: "vouchers", label: "Coduri", C: VouchersAdmin },
  { key: "shipping", label: "Livrare", C: ShippingAdmin },
  { key: "newsletter", label: "Abonați", C: NewsletterAdmin },
  { key: "content", label: "Conținut", C: ContentAdmin },
];

const Admin = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("products");
  const Active = TABS.find((t) => t.key === tab).C;

  return (
    <div className="min-h-screen bg-white" data-testid="admin-page">
      <div className="flex items-center justify-between border-b border-border px-5 py-3">
        <div className="flex items-center gap-4">
          <img src="/logo.png" alt="LAINER" className="h-4 w-auto" />
          <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">Admin</span>
        </div>
        <div className="flex items-center gap-4">
          <Link to="/" className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">Vezi magazinul ↗</Link>
          <span className="hidden font-mono text-[11px] uppercase tracking-widest text-muted-foreground sm:inline">{user?.email}</span>
          <button data-testid="logout-btn" onClick={() => { logout(); navigate("/login"); }} className="font-mono text-[11px] uppercase tracking-widest hover:opacity-60">Ieși</button>
        </div>
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-1 border-b border-border px-5 py-2">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`admin-tab-${t.key}`}
            className={`font-mono text-[11px] uppercase tracking-widest transition-opacity ${tab === t.key ? "opacity-100 underline underline-offset-4" : "opacity-45 hover:opacity-100"}`}>
            {t.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
};

export default Admin;
